module.exports = __webpack_public_path__ + "static/media/logo-넷앤드@3x.c413262c.png";